import { z } from "zod";
import {
  DeprecatedAnthropicModelLiteral,
  ExperimentalAnthropicModelLiteral,
  StableAnthropicModelLiteral,
} from "./anthropicTypes";
import {
  DeprecatedOpenAiChatModelLiteral,
  OpenAiChatModelLiteral,
} from "./openAiTypes";
import { ChatCompletionsModelLiteral } from "./chatCompletionsTypes";
import { getNormalEnum } from "../pseudoEnums";

/** @deprecated */
export const DeprecatedModelLiteral = z.enum([
  ...DeprecatedAnthropicModelLiteral.options,
  ...DeprecatedOpenAiChatModelLiteral.options,
]);
/** @deprecated */
export type DeprecatedModel = z.infer<typeof DeprecatedModelLiteral>;
/** @deprecated */
export const DeprecatedModel = getNormalEnum(DeprecatedModelLiteral);

export const StableModelLiteral = z.enum([
  ...StableAnthropicModelLiteral.options,
  ...OpenAiChatModelLiteral.options,
  ...ChatCompletionsModelLiteral.options,
]);
export type StableModel = z.infer<typeof StableModelLiteral>;
export const StableModel = getNormalEnum(StableModelLiteral);

export const ExperimentalModelLiteral = z.enum([
  ...ExperimentalAnthropicModelLiteral.options,
]);
export type ExperimentalModel = z.infer<typeof ExperimentalModelLiteral>;
export const ExperimentalModel = getNormalEnum(ExperimentalModelLiteral);

export const ModelLiteral = z.enum([
  ...StableModelLiteral.options,
  ...ExperimentalModelLiteral.options,
]);
export type Model = z.infer<typeof ModelLiteral>;
export const Model = getNormalEnum(ModelLiteral);
